import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import 'react-widgets/dist/css/react-widgets.css';
import Loader from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

var monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];

class Development extends Component {
    constructor() {
        super();
        this.state = {
            successResp: false,
            data: [],
            selectedDate: new Date(),
            roleList: []
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchRolesApi();
            this.fetchDevTeamDetailsApi();
        }, 300);

        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchRolesApi(event.projectId);
            thisController.fetchDevTeamDetailsApi(event.projectId);
        });
    }

    fetchRolesApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var roleController = this;
        $.ajax(
            {
                url: "/api/project-roles",
                async: false,
                method: 'GET',
                data: {
                    projectId: projectId,
                },
                headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {
                    if (res.success === true) {
                        var roles = res.result;
                        roleController.state.roleList = roles
                        roleController.setState(roleController.state);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            }
        )
    }

    fetchDevTeamDetailsApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var devTeamComponent = this;
        var selectedDate = devTeamComponent.state.selectedDate;
        selectedDate = selectedDate.getDate() + "-" + monthNames[parseInt(selectedDate.getMonth())] + "-" + selectedDate.getFullYear();
        selectedDate = btoa(selectedDate);
        $.ajax({
            url: "/api/user-session-info-dev-team",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId,
                "date": selectedDate
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                devTeamComponent.state.successResp = true;
                if (res.success === true) {
                    devTeamComponent.state.data = res.result;
                    for (var i = 0; i < res.result.length; i++) {
                        const loginTime = res.result[i].loginTime == 0 ? 0 : new Date(res.result[i].loginTime)
                        const logoutTime = res.result[i].logoutTime == 0 ? 0 : new Date(res.result[i].logoutTime)
                        devTeamComponent.state.data[i].loginTime = loginTime == 0 ? "-" : loginTime.getDate() + "/" + parseInt(loginTime.getMonth() + 1) + "/" + loginTime.getFullYear() + " " + loginTime.getHours() + ":" + loginTime.getMinutes() + ":" + loginTime.getSeconds();
                        devTeamComponent.state.data[i].logoutTime = logoutTime == 0 ? "-" : logoutTime.getDate() + "/" + parseInt(logoutTime.getMonth() + 1) + "/" + logoutTime.getFullYear() + " " + loginTime.getHours() + ":" + loginTime.getMinutes() + ":" + loginTime.getSeconds();
                        for (var j = 0; j < devTeamComponent.state.roleList.length; j++) {
                            if (devTeamComponent.state.data[i].userType == devTeamComponent.state.roleList[j].code) {
                                devTeamComponent.state.data[i].userType = devTeamComponent.state.roleList[j].name;
                                break;
                            }
                        }
                    }
                    devTeamComponent.setState(devTeamComponent.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    refreshData = () => {
        this.fetchDevTeamDetailsApi()
    }

    onDateChange = (date) => {
        this.state.selectedDate = date;
        this.setState(this.state);
        this.fetchDevTeamDetailsApi();
    }


    render() {
        const columns = [
            {
                Header: <b>User Name</b>,
                textAlign: 'screenLeft',
                accessor: 'userName',
                sortable: false,
                Cell: props => {
                    return (
                        (<div
                            Align="left" className="input"
                            style={{
                                padding: '8px', width: '98%', borderBottom: 'none',
                                border: 'none', paddingLeft: '2px'
                            }}
                            suppressContentEditableWarning
                            contentEditable={false}
                            type="text">{props.original.username}</div>)
                    )
                },
            }, {
                Header: <b>User Email ID</b>,
                accessor: 'useEmailId',
                sortable: false,
                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '98%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.userEmailId}</div>)
                }
            }, {
                Header: <b>Mobile Number</b>,
                accessor: 'mobileNumber',
                sortable: false,
                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '98%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.userMobileNumber}</div>)
                },
            },
            {
                Header: <b>Role</b>,
                textAlign: 'screenLeft',
                accessor: 'role',
                sortable: false,
                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '98%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.userType}</div>)
                },
            },
            {
                Header: <b>Login Time</b>,
                accessor: 'loginTime',
                sortable: false,
                Cell: props => {
                    return (
                        <div
                            Align="left" className="input"
                            style={{
                                padding: '8px', width: '98%', borderBottom: 'none',
                                border: 'none', paddingLeft: '2px'
                            }}
                            suppressContentEditableWarning
                            contentEditable={false}
                            type="text">{props.original.loginTime}</div>)
                }
            }, {
                Header: <b>Logout Time</b>,
                accessor: 'logoutTime',
                sortable: false,
                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '98%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.logoutTime}</div>)
                },
            }
        ]

        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.successResp}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />
                <ToastContainer className="Toast-at-center" />

                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">


                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginTop: '24px', marginLeft: '2px'
                                }}>Development Team - Last Login Information</h6>
                            </div>
                            {/* refresh button*/}
                            <div className="col-sm-6 p-0" align="right">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                        <img src="./assets/images/refresh_white_24dp.png"></img>
                                    </button>
                                    <div align='right'>
                                        <DatePicker
                                            id="date"
                                            selected={this.state.selectedDate}
                                            onChange={this.onDateChange}
                                            dateFormat="dd/MM/yyyy">
                                        </DatePicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row" >
                                <div className="col-lg-12 ">
                                    <div className="card" >
                                        <ReactTable
                                            data={this.state.data}
                                            columns={columns}
                                            defaultPageSize={5}
                                            pageSizeOptions={[5, 10, 15]}

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )

    }
}

export default Development;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/audit/DevelopmentTeam.js